export default __webpack_public_path__ + "static/media/page-1.7504bd98.png";